import { useState, useEffect, useMemo} from "react"
import moment from "moment"

import {searchStories} from "../api/story/requests";
import { useShowErrorFlashMessage } from "../features/flashMessage/store";

function useCrunchyrollArticleSearch({
  pageSize,
  page,
  language,
  term,
  category,
  orderBy,
  startDate,
  endDate
}) {
  const [currentArticles,setCurrentArticles ] = useState([]),
        [totalArticles,setTotalArticles] = useState(0),
        [isLoading,setIsLoading] = useState(term ? true : false)

  const showErrorFlashMessage = useShowErrorFlashMessage()

  const start = useMemo(()=>{
    if(startDate) {
      const d = moment(startDate)
      return d.format()
    }
    return ""
  },[startDate])
  const end = useMemo(()=>{
    if(endDate) {
      const d = moment(endDate)
      return d.format()
    }
    return ""
  },[endDate])

  const currentCacheKey = `${pageSize}:${language}:${term}:${category || ''}:${orderBy || ''}:${start || ''}_${end || ''}`

  const [cache,setCache] = useState({}),
        [cacheKey,setCacheKey] = useState(currentCacheKey)

  useEffect(()=>{
    if(currentCacheKey !== cacheKey) {
      setCache({})
      setCacheKey(currentCacheKey)
      setCurrentArticles([])
    }
  },[pageSize,language,term,category,orderBy,start,end])

  useEffect(()=>{
    // look in cache first
    if(cache[page]) {
      setCurrentArticles(cache[page])
    } else {
      if(!term) {
        setCurrentArticles([])
        setTotalArticles(0)
        return;
      }
      setIsLoading(true)
      setCurrentArticles([])
      searchStories({
        term,
        page,
        pageSize,
        category,
        orderBy,
        startDate: start,
        endDate: end
      })
        .then((data)=>{
          setTotalArticles(data.total)
          const newCache = {
            ...cache,
            [page]: data.articles
          }
          setCache(newCache)
          setCurrentArticles(data.articles || [])
        })
        .catch((err)=>{
          setTotalArticles(0)

          if (err.status !== 404) {
            showErrorFlashMessage("api.network_error")
            console.error(err)
          }
        })
        .finally(() => {
          setIsLoading(false)
        }
        )
    }
  },[cacheKey,page])


  return [currentArticles,totalArticles,isLoading]
}


export {
  useCrunchyrollArticleSearch,
}
